

<script>
import { Pie } from 'vue-chartjs'
import { setTimeout } from 'timers';
export default {
  extends: Pie,
  data() {
      return {
          comrate:0,
          corate:0,
          rurate:0,
          piedata:[]
      }
  },
  mounted () {
         this.setData()
    this.renderChart({
      labels: ['onedio.com','onedio.co','onedio.ru'],
      datasets: [
        {
          backgroundColor: [
            '#20a8d8',
            '#ffc107',
            '#4dbd74'
          ],
          data:this.piedata
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  },
  methods: {
     async setData(){
       this.corate=parseFloat(this.$store.state.coRate)
        this.rurate=parseFloat(this.$store.state.ruRate)
       this.comrate=parseFloat(this.$store.state.comRate)
        this.piedata.push(this.comrate)
        this.piedata.push(this.corate)
        this.piedata.push(this.rurate)
      }
  },
}
</script>
